import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const USER_NAV = [
  { path:'/dashboard', icon:'🏠', label:'Dashboard', exact:true },
  { path:'/dashboard/tests', icon:'📝', label:'Mock Tests', exact:false },
  { path:'/dashboard/history', icon:'📊', label:'My Results', exact:false },
  { path:'/dashboard/profile', icon:'👤', label:'My Profile', exact:false },
];

const ADMIN_NAV = [
  { path:'/admin', icon:'📊', label:'Overview', exact:true },
  { path:'/admin/users', icon:'👥', label:'Users', exact:false },
  { path:'/admin/payments', icon:'💰', label:'Payments', exact:false },
  { path:'/admin/questions', icon:'❓', label:'Questions', exact:false },
  { path:'/admin/tests', icon:'📝', label:'Tests', exact:false },
];

const Sidebar = ({ isAdmin, mobileOpen, onClose }) => {
  const loc = useLocation();
  const { user, admin, logout } = useAuth();
  const nav = ADMIN_NAV.filter(n => !isAdmin || true);
  const navItems = isAdmin ? ADMIN_NAV : USER_NAV;
  const person = isAdmin ? admin : user;

  return (
    <>
      {mobileOpen && (
        <div onClick={onClose} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:99, backdropFilter:'blur(3px)' }} />
      )}
      <aside style={{ width:'var(--sidebar-w)', flexShrink:0, background:'linear-gradient(180deg,#060f2e 0%,#0d1e4d 40%,#1A3C8F 100%)', position:'fixed', top:0, left:0, height:'100vh', overflowY:'auto', zIndex:100, display:'flex', flexDirection:'column', transition:'transform 0.3s cubic-bezier(0.4,0,0.2,1)', transform: mobileOpen ? 'translateX(0)' : undefined }} id="sidebar">

        {/* Logo */}
        <div style={{ padding:'22px 20px 16px', borderBottom:'1px solid rgba(255,255,255,0.06)' }}>
          <Link to={isAdmin ? '/admin' : '/dashboard'} style={{ display:'flex', alignItems:'center', gap:11, textDecoration:'none' }}>
            <div style={{ width:38, height:38, background:'rgba(245,166,35,0.18)', border:'1.5px solid rgba(245,166,35,0.38)', borderRadius:10, display:'flex', alignItems:'center', justifyContent:'center', fontSize:18, flexShrink:0 }}>🏆</div>
            <div>
              <div style={{ fontFamily:'var(--font-heading)', fontSize:18, fontWeight:700, color:'#fff', lineHeight:1.1 }}>TNPSC <span style={{ color:'var(--gold)' }}>Hub</span></div>
              <div style={{ fontSize:9, color:'rgba(255,255,255,0.3)', letterSpacing:'1.2px', textTransform:'uppercase', marginTop:2 }}>{isAdmin ? 'Admin Panel' : 'Student Portal'}</div>
            </div>
          </Link>
        </div>

        {/* User info */}
        <div style={{ padding:'14px 16px', borderBottom:'1px solid rgba(255,255,255,0.05)', margin:'0 8px', marginTop:8 }}>
          <div style={{ display:'flex', alignItems:'center', gap:10, background:'rgba(255,255,255,0.05)', borderRadius:12, padding:'11px 13px' }}>
            <div style={{ width:36, height:36, borderRadius:'50%', background:'linear-gradient(135deg,var(--gold),var(--gold-dark))', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:800, fontSize:15, color:'var(--blue-dark)', flexShrink:0 }}>
              {(person?.full_name || person?.name || 'U')[0].toUpperCase()}
            </div>
            <div style={{ overflow:'hidden', flex:1 }}>
              <div style={{ fontSize:13, fontWeight:600, color:'#fff', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{person?.full_name || person?.name}</div>
              <div style={{ fontSize:10, color:'rgba(255,255,255,0.35)', marginTop:1 }}>
                {isAdmin ? 'Administrator' : user?.exam_group}
              </div>
            </div>
          </div>
        </div>

        {/* Nav */}
        <nav style={{ flex:1, padding:'10px 8px', overflowY:'auto' }}>
          <div style={{ fontSize:9, color:'rgba(255,255,255,0.25)', letterSpacing:'1.5px', textTransform:'uppercase', padding:'8px 12px 6px', marginBottom:2 }}>Menu</div>
          {navItems.map(item => {
            const active = item.exact ? loc.pathname === item.path : loc.pathname.startsWith(item.path);
            return (
              <Link key={item.path + item.label} to={item.path} onClick={onClose} style={{ display:'flex', alignItems:'center', gap:11, padding:'11px 14px', borderRadius:11, marginBottom:2, textDecoration:'none', transition:'all 0.2s', background: active ? 'rgba(255,255,255,0.1)' : 'transparent', color: active ? '#fff' : 'rgba(255,255,255,0.5)', borderLeft: `3px solid ${active ? 'var(--gold)' : 'transparent'}` }}
                onMouseEnter={e => { if (!active) e.currentTarget.style.background='rgba(255,255,255,0.06)'; }}
                onMouseLeave={e => { if (!active) e.currentTarget.style.background='transparent'; }}>
                <span style={{ fontSize:17, width:22, textAlign:'center', flexShrink:0 }}>{item.icon}</span>
                <span style={{ fontSize:13, fontWeight: active ? 600 : 400 }}>{item.label}</span>
                {active && <div style={{ marginLeft:'auto', width:6, height:6, borderRadius:'50%', background:'var(--gold)', flexShrink:0 }} />}
              </Link>
            );
          })}
        </nav>

        {/* Bottom */}
        <div style={{ padding:'8px 8px 20px', borderTop:'1px solid rgba(255,255,255,0.05)' }}>
          {!isAdmin && (
            <Link to="/" style={{ display:'flex', alignItems:'center', gap:11, padding:'10px 14px', borderRadius:11, color:'rgba(255,255,255,0.4)', textDecoration:'none', fontSize:13, marginBottom:4, transition:'all 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.color='rgba(255,255,255,0.7)'}
              onMouseLeave={e => e.currentTarget.style.color='rgba(255,255,255,0.4)'}>
              <span style={{ fontSize:17, width:22, textAlign:'center' }}>🌐</span> Home Page
            </Link>
          )}
          <button onClick={logout} style={{ display:'flex', alignItems:'center', gap:11, padding:'10px 14px', borderRadius:11, color:'rgba(255,100,100,0.8)', background:'rgba(220,53,69,0.07)', border:'none', cursor:'pointer', fontFamily:'var(--font-body)', fontSize:13, width:'100%', transition:'all 0.2s' }}
            onMouseEnter={e => e.currentTarget.style.background='rgba(220,53,69,0.14)'}
            onMouseLeave={e => e.currentTarget.style.background='rgba(220,53,69,0.07)'}>
            <span style={{ fontSize:17, width:22, textAlign:'center' }}>🚪</span> Logout
          </button>
        </div>
      </aside>
    </>
  );
};

export const DashboardLayout = ({ children, title, subtitle, actions, isAdmin = false }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const loc = useLocation();
  const { user, admin } = useAuth();
  const person = isAdmin ? admin : user;

  return (
    <div style={{ display:'flex', minHeight:'100vh' }}>
      <Sidebar isAdmin={isAdmin} mobileOpen={menuOpen} onClose={() => setMenuOpen(false)} />
      <div style={{ marginLeft:'var(--sidebar-w)', flex:1, minHeight:'100vh', background:'var(--bg)', display:'flex', flexDirection:'column' }} id="main-content">
        {/* Topbar */}
        <div style={{ height:64, background:'#fff', borderBottom:'1px solid var(--border)', padding:'0 28px', display:'flex', alignItems:'center', justifyContent:'space-between', position:'sticky', top:0, zIndex:99, boxShadow:'0 2px 12px rgba(26,60,143,0.05)' }}>
          <div style={{ display:'flex', alignItems:'center', gap:14 }}>
            <button id="menu-btn" onClick={() => setMenuOpen(true)} style={{ display:'none', background:'none', border:'none', fontSize:22, cursor:'pointer', padding:4, color:'var(--dark)' }}>☰</button>
            <div>
              <h1 style={{ fontFamily:'var(--font-heading)', fontSize:20, fontWeight:700, color:'var(--dark)', lineHeight:1.2 }}>{title}</h1>
              {subtitle && <p style={{ fontSize:12, color:'var(--muted)', marginTop:1 }}>{subtitle}</p>}
            </div>
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:10 }}>
            {actions}
            <div style={{ width:36, height:36, borderRadius:'50%', background:'linear-gradient(135deg,var(--blue),var(--blue-mid))', display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', fontWeight:700, fontSize:14, flexShrink:0, cursor:'default' }}>
              {(person?.full_name || person?.name || 'U')[0].toUpperCase()}
            </div>
          </div>
        </div>
        {/* Page content */}
        <div style={{ padding:28, flex:1 }}>{children}</div>
      </div>
      <style>{`
        @media(max-width:768px){
          #menu-btn{display:flex!important}
          #main-content{margin-left:0!important}
          #sidebar{transform:translateX(-100%)}
        }
      `}</style>
    </div>
  );
};
